import axios from "axios";
import {forceLogout, getAccessToken} from "./authority";
import {toast} from "react-toastify";

// Get language from localStorage, default to 'vi'
const getLang = () => localStorage.getItem('sas_school_language') || 'vi';
let lang = getLang();


let token = getAccessToken();

export const request = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    if (token === undefined)
        token = getAccessToken();
    const abortController = request.timeoutMs ? new AbortController() : null;
    const timeoutId = abortController
        ? setTimeout(() => abortController.abort(), request.timeoutMs)
        : null;
    let config = {
        method: request.method,
        headers: token ?  {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json; charset=UTF-8",
            "Accept-Language": lang
        } : {
            "Content-Type": "application/json; charset=UTF-8",
            "Accept-Language": lang
        },
        body: JSON.stringify(request.body),
        signal: abortController ? abortController.signal : undefined
        // body: request.body
    }
    return fetch(request?.url,config)
        .then(async response => {
            if (response?.status === 401) {
                await forceLogout();
            }
            // else if (response?.status == 500) {
            //     return {"success":true,"data": null,"errorCode":null,"message":null,"refCode":null}
            // }
            // console.log("check response fetch>>>>", response)
            return response.json()
        })
        .then((res) => {
            callback(res);
        })
        .catch((error) => {
            console.error('API Error:', error);
            if (error?.name === 'AbortError') {
                if (callback) {
                    callback({
                        success: false,
                        errorCode: 'REQUEST_TIMEOUT',
                        message: 'Yêu cầu quá thời gian chờ, vui lòng thử lại'
                    });
                }
                return;
            }
            if (callback) {
                callback({ success: false, errorCode: 'NETWORK_ERROR', message: error?.message || 'Lỗi kết nối mạng' });
            }
        })
        .finally(() => {
            if (timeoutId) clearTimeout(timeoutId);
        })
};

export const requestLogin = (request, callback) =>{
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "Accept-Language": lang
        },
        body: JSON.stringify(request.body)
        // body: request.body
    }
    return fetch(request?.url,config)
        .then(async response => {
            if (response?.status === 401) {
                toast.error("Sai tên đăng nhập hoặc mật khẩu!")
            }
            return response.json()
        })
        .then((res) => {
            callback(res);
        })
        .catch((error) => {
            console.log(error)
            toast.error("Sai tên đăng nhập hoặc mật khẩu!")
            // callback(error.json())
        })
};

export const requestUploadPublic = (request, callback) =>{
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Accept-Language": lang
        },
        // body: JSON.stringify(request.body)
        body: request.body
    }
    return fetch(request?.url,config)
        .then(async response => {
            if (response?.status === 401) {
                // await forceLogout();
            }
            return response.json()
        })
        .then((res) => {
            callback(res);
        })
        .catch((error) => {
            console.error('Upload Public Error:', error);
            if (callback) {
                callback({ success: false, errorCode: 'NETWORK_ERROR', message: error?.message || 'Lỗi kết nối mạng' });
            }
        });
};

export const requestUpload = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Authorization": "Bearer " + token,
            "Accept-Language": lang
        },
        body: request.body,
    }
    return fetch(request?.url,config)
        .then(async response => {
            if (response?.status === 401) {
                await forceLogout();
            }
            return response.json()
        })
        .then((res) => {
            callback(res);
        })
        .catch((error) => {
            console.error('Upload Error:', error);
            if (callback) {
                callback({ success: false, errorCode: 'NETWORK_ERROR', message: error?.message || 'Lỗi kết nối mạng' });
            }
        });
};

export const requestDownload = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Authorization": "Bearer " + token,
            // "Content-Type": "multipart/form-data",
            "Accept-Language": lang
        },
        // body: JSON.stringify(request.body)
        body: request.body
    }
    return fetch(request?.url,config)
        .then(async response => {
            if (response?.status === 401) {
                await forceLogout();
            }
            else if (response?.status === 500) {
                return response.json()
            }
            else if (response?.status === 400) {
                return response.json()
            }
            else if (response?.status === 404) {
                toast.error("File không tồn tại hoặc đã bị mất, vui lòng thử lại!")
                return response.json()
            }
            else return response.blob()
        })
        .then((res) => {
            if (res) {
                const fileURL = URL.createObjectURL(res);
                let a = document.createElement('a');
                a.href = fileURL;
                a.download = request.fileName;
                a.click();
                // Revoke objectURL to prevent memory leak
                setTimeout(() => URL.revokeObjectURL(fileURL), 100);
            }
            callback({
                success: true
            });
        })
        .catch(error => {
            console.error('Download Error:', error);
            if (error?.status === 404) {
                return toast.error("File không tồn tại hoặc đã bị mất, vui lòng thử lại!");
            }
            return toast.error("Download không thành công, vui lòng thử lại!");
        })
};
export const requestShow = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Authorization": "Bearer " + token,
            // "Content-Type": "multipart/form-data",
            "Accept-Language": lang
        },
        // body: JSON.stringify(request.body)
        body: request.body
    }
    return fetch(request?.url,config)
        .then(async response => {
            if (response?.status === 401) {
                await forceLogout();
            }
            else if (response?.status === 500) {
                return response.json()
            }
            else if (response?.status === 400) {
                return response.json()
            }
            else if (response?.status === 404) {
                toast.error("File không tồn tại hoặc đã bị mất, vui lòng thử lại!")
                return response.json()
            }
            else return response.blob()
        })
        .then((res) => {
            // if (!res.success) {
            //     return toast.error("Download không thành công, vui lòng thử lại!")
            // }  else {
            if (res) {
                const fileURL = URL.createObjectURL(res);
                callback(fileURL);
            }
            // }
            // const fileURL = URL.createObjectURL(res);
            // // window.open(fileURL)
            // saveAs(fileURL);
            // callback(fileURL);
        })
        .catch(error => {
            console.error('Show Error:', error);
            if (error?.status === 404) {
                return toast.error("File không tồn tại hoặc đã bị mất, vui lòng thử lại!");
            }
            return toast.error("Download không thành công, vui lòng thử lại!");
        })
};
export const requestv2 = (request, callback) =>{
    token = getAccessToken();
    let config = {
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json; charset=UTF-8"
        }
    }
    // return axios.get(request?.url, request?.config).then((res) => {
    return axios.get(request?.url, config).then((res) => {
        // if (thrown?.response?.status == 401) {
        //TODO: call dispatch logout
        // await forceLogout();
        // }
        callback(res.data);
    }).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
            // console.log('First request canceled', thrown?.message);
        } else {
            // handle error
            if (thrown?.response?.status === 401) {
                //TODO: call dispatch logout
                forceLogout();
            }
        }
    });
};
